import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// locals
// assets
import successImage from 'assets/images/success-image.svg'
import { IFilteredGymGroupList } from 'types/GymType'
import NotificationDialog from 'components/ui/NotificationDialog'
import GymGroupCard from './GymGroupCard'
import GroupLessonReservationSidebar from './GroupLessonReservationSidebar'

interface ComponentProps {
  renderList: IFilteredGymGroupList[]
  runAfterSubmit: () => void
}

export default function GymGroupCardContainer({ renderList, runAfterSubmit }: ComponentProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [notification, setNotification] = useState(false)
  const [selectedLesson, setSelectedLesson] = useState<IFilteredGymGroupList>()

  const openModal = (lesson?: IFilteredGymGroupList) => {
    setSidebarVisible(true)
    if (lesson) setSelectedLesson(lesson)
  }

  const closeAfterSave = () => {
    setSidebarVisible(false)
    setNotification(true)
    runAfterSubmit()
  }

  const closeNotification = () => {
    runAfterSubmit()
    setNotification(false)
  }

  return (
    <>
      {renderList?.map((lesson) => (
        <GymGroupCard key={lesson.id} lesson={lesson} openModal={openModal} />
      ))}

      {selectedLesson && (
        <GroupLessonReservationSidebar
          groupLessonInfo={selectedLesson}
          setVisible={setSidebarVisible}
          visible={sidebarVisible}
          closeAfterSave={closeAfterSave}
        />
      )}

      {!!notification && (
        <NotificationDialog
          display={notification}
          imgSrc={successImage}
          goHomeButton={true}
          title={t('gym-res-modal.notification-title')}
          content={t('gym-res-modal.notification-text')}
          firstButtonLabel={t('buttons.go-to-calendar')}
          onHide={closeNotification}
          onSubmit={() => history.push('/calendar')}
          selectedType={null}
          setSelectedType={undefined}
          types={[]}
        />
      )}
    </>
  )
}
